import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c9cc138&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=3c9cc138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9cc138",
  null
  
)

export default component.exports